import React from 'react';

import CandidatsDropdown from './CandidatsDropdown';

class DefaultDropdown extends React.PureComponent {
  render() {
    return (
      <CandidatsDropdown
        initialData={{ items: [] }}
        value={null}
        onChange={() => {}}
      />
    );
  }
}

export default DefaultDropdown;
